/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 698
// module chunks = 0